import React, { useEffect, useState, memo, useCallback } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import '../styles/Navbar.css';

const Navbar = ({ activeSection = 'hero', onNavigate = null }) => {
  const { t } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  const [clickedId, setClickedId] = useState(null);

  const NAV_ITEMS = [
    { id: 'hero', label: t.nav.home },
    { id: 'about', label: t.nav.about },
    { id: 'experience', label: t.nav.experience },
    { id: 'projects', label: t.nav.projects },
    { id: 'contact', label: t.nav.contact },
  ];

  useEffect(() => {
    let rafId = null;

    const handleScroll = () => {
      if (rafId) return;

      rafId = window.requestAnimationFrame(() => {
        setScrolled(window.scrollY > 50);
        rafId = null;
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (rafId) window.cancelAnimationFrame(rafId);
    };
  }, []);

  const handleNavClick = useCallback((id) => (e) => {
    e.preventDefault();
    setClickedId(id);
    window.setTimeout(() => setClickedId(null), 300);

    if (typeof onNavigate === 'function') {
      onNavigate(id);
    }
  }, [onNavigate]);

  return (
    <motion.nav 
      className={`navbar ${scrolled ? 'scrolled' : ''}`}
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ 
        duration: 0.4, 
        ease: [0.22, 1, 0.36, 1],
      }}
    >
      <div className="nav-container">
        <ul className="nav-menu" aria-label="Primary">
          {NAV_ITEMS.map((item, index) => (
            <motion.li 
              key={item.id} 
              className="nav-item"
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ 
                duration: 0.3, 
                delay: 0.1 + index * 0.05,
                ease: [0.22, 1, 0.36, 1],
              }}
            >
              <motion.a
                href={`#${item.id}`}
                className={`nav-link ${activeSection === item.id ? 'active' : ''} ${clickedId === item.id ? 'animate-click' : ''}`}
                onClick={handleNavClick(item.id)}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                {item.label}
              </motion.a>
            </motion.li>
          ))}
        </ul>
      </div>
    </motion.nav>
  );
};

export default memo(Navbar);
